:host {
  /**
   * @prop --background: Background of the segment button
   */
  --ripple-color: currentColor;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: grid;
  grid-auto-columns: 1fr;
  position: relative;
  align-items: stretch;
  justify-content: center;
  width: 100%;
  background: var(--background);
  font-family: var(--ion-font-family, inherit);
  text-align: center;
  contain: paint;
  user-select: none;
}

:host(.segment-scrollable) {
  justify-content: start;
  width: auto;
  overflow-x: auto;
  grid-auto-columns: minmax(min-content, 1fr);
}

:host(.segment-scrollable::-webkit-scrollbar) {
  display: none;
}

:host {
  --background: rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.065);
  border-radius: 8px;
  overflow: hidden;
  z-index: 0;
}

:host(.ion-color) {
  background: rgba(var(--ion-color-base-rgb), 0.065);
}

:host(.in-toolbar) {
  -webkit-margin-start: auto;
  margin-inline-start: auto;
  -webkit-margin-end: auto;
  margin-inline-end: auto;
  margin-top: 0;
  margin-bottom: 0;
  width: auto;
}

:host(.in-toolbar:not(.ion-color)) {
  background: var(--ion-toolbar-segment-background, var(--background));
}

:host(.in-toolbar-color:not(.ion-color)) {
  background: rgba(var(--ion-color-contrast-rgb), 0.11);
}